import InstagramEmbed, { toEmbedUrl } from "./InstagramEmbed";

export default function InstagramVideoSection({ url, accentClass = "text-orange-400" }) {
  if (!toEmbedUrl(url)) {
    return null;
  }

  return (
    <section className="px-4 py-14 md:py-20" data-testid="landing-video-section">
      <div className="container mx-auto max-w-4xl">
        <div className="mb-8 text-center">
          <p className={`mb-2 text-xs font-medium uppercase tracking-widest ${accentClass}`}>
            Відео
          </p>
          <h2 className="text-3xl font-black text-white md:text-5xl">
            Дивіться, як проходить робота
          </h2>
        </div>
        <InstagramEmbed url={url} />
      </div>
    </section>
  );
}